<template>
  <div class="filtrate-container custom-side-filter">
    <transition name="van-fade">
      <div v-show="visible" class="mask" @click="close"></div>
    </transition>

    <transition name="van-slide-right">
      <div class="side wrap" v-show="visible">
        <div class="main">
          <van-cell
            title="校区"
            is-link          
            :value-class="['van-ellipsis', campusText ? 'selected':'']"
            :value="campusText||'请选择'"
            @click="chooseCampus"
          />

          <van-cell
            title="课程"
            is-link
            :value-class="['van-ellipsis', curriculumText ? 'selected':'']"
            :value="curriculumText||'请选择'"
            @click="chooseCourse"
          />

          <van-cell
            title="班级"
            is-link
            :value-class="['van-ellipsis', classText ? 'selected':'']"
            :value="classText||'请选择'"
            @click="chooseClass"
          />

          <div class="three-a-row" v-if="config.enableTagFilter">
            <div class="nav-title">学员状态</div>
            
            <div class="nav-div">            
              <div class="nav-box" v-for="item of stuStaList" :key="item.id">
                <div
                  class="item-nav"
                  :class="{
                    active: params.status && params.status.includes(item.val),
                    all: ((!params.status || !params.status.length) && item.val === ''),
                  }"
                  @click="triggerStuSta(item)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <van-row class="footer" gutter="12">
          <van-col span="12">
            <van-button block square round @click="reset"> 重置 </van-button>
          </van-col>
          <van-col span="12">
            <van-button block square round type="primary" @click="confirm">
              确定
            </van-button>
          </van-col>
        </van-row>
      </div>
    </transition>
  </div>
</template>

<script>
let defaultParams = {
  // 校区ids
  campusIds: [],
  campusList: [],
  // 课程id集合
  curriculumIds: [],
  curriculumList: [],
  // 班级id集合
  studentClassIds: [],
  classList: [],
  // 学员状态ids
  status: [1],
};

export default {
  name: "",  
  inject: ['studentsStatusDict'],
  data() {
    return {
      visible: false,
      tagList: [],
      params: JSON.parse(JSON.stringify(defaultParams)),
      config: {
        // 是否开启学员状态筛选
        enableTagFilter: true,
        enableStudentStatusIds: [1, 6],
      },
    };
  },
  computed: {
    campusText: function () {
      let cps = this.params.campusList,
        text = "";
      if (cps.length == 1) {
        text = cps[0].name;
      } else if (cps.length > 1) {
        text = `${cps.length}个校区`;
      }
      return text;
    },
    curriculumText: function () {
      if (this.params.curriculumList[0]) {
        return this.params.curriculumList[0].curriculumName;
      } else {
        return "";
      }
    },
    classText: function () {
      if (this.params.classList[0]) {
        return this.params.classList[0].className;
      } else {
        return "";
      }
    },
    hasFilter: function () {
      if (this.displayHistory) return true;
      let len1 = this.params.campusIds.length;
      let len2 = this.params.curriculumIds.length;
      let len4 = this.params.studentClassIds.length;
      let len5 = this.params.status.length;
      let len = len1 + len2  + len4 + len5;
      if (len > 0) {
        return true;
      }
      return false;
    },
    stuStaList() {
      let arr = [];
      for (let prop in this.studentsStatusDict) {
        this.config.enableStudentStatusIds.includes(Number(prop)) && arr.push({ id: prop, val: Number(prop), name: this.studentsStatusDict[prop] });
      }
      return arr;
    },
  },
  methods: {
    prevInit() {
      if (!this.$route.meta._resolve) {
        setTimeout(() => {
          this.$router.back();
        }, 0);
      } else {
        let opts = this.$route.meta.options || {};
        this._resolve = this.$route.meta._resolve;
        this._reject = this.$route.meta._reject;
        if (opts.config) {
          this.config = Object.assign(this.config, opts.config);
        }
        if (opts.params) {
          let params = JSON.parse(JSON.stringify(opts.params));
          this.params = Object.assign(this.params, params);
        }

        setTimeout(() => {
          this.visible = true;
        }, 0);
      }
    },

    // 选择校区
    async chooseCampus() {
      let res = await app.x3.side.xsCampus({
        ids: this.params.campusIds,
        list: this.params.campusList,
      });

      let oIdsStr = this.params.campusIds.join(),
        nOdsStr = res.ids.join();
      // 如果选中的校区发生变化
      if (oIdsStr != nOdsStr) {
        this.params.campusIds = res.ids;
        this.params.campusList = res.list;

        this.params.curriculumIds = [];
        this.params.curriculumList = [];

        this.params.studentClassIds = [];
        this.params.classList = [];
      }
    },
    // 选择课程
    async chooseCourse() {
      let res = await app.x3.side.xsCourse({
        id: this.params.curriculumIds[0],
      });

      this.params.curriculumIds = res ? [res.curriculumId] : [];
      this.params.curriculumList = res ? [res] : [];

      this.params.studentClassIds = [];
      this.params.classList = [];
    },
    // 选择班级
    async chooseClass() {
      let res = await app.x3.side.xsClass({
        id: this.params.studentClassIds[0],
        params: {
          campusIds: this.params.campusIds,
          campusList: this.params.campusList,
          curriculumIds: this.params.curriculumIds,
          classStatus: ''
        },
        config: {          
          radio: true,
          enableFilter: false,
        },
        filter: {
          enableCampusFilter: false,
        }
      });
      
      this.params.studentClassIds = res ? [res.id] : [];
      this.params.classList = res ? [res] : [];
    },
    // 学业状态处理
    triggerStuSta(item) {
      let i = this.params.status.indexOf(item.val);
      if (i === -1) {
        this.params.status.push(item.val);
      } else {
        this.params.status.splice(i, 1);
      }

    },
    // 重置
    async reset() {
      this.params = JSON.parse(JSON.stringify(defaultParams));
    },
    render() {
      this.$api.tagList().then((res) => {
        this.tagList = res.data;
      });
    },
    doneAnima() {
      this.$router.back();
      return new Promise((rsv) => {
        setTimeout(() => {
          rsv();
        }, 100);
      });
    },
    async close() {
      await this.doneAnima();
    },
    async confirm() {
      await this.doneAnima();
      this._resolve(
        JSON.parse(
          JSON.stringify({
            params: this.params,
            hasFilter: this.hasFilter,
          })
        )
      );
    },
  },
  created() {
    this.prevInit();
    this.render();
  },
  beforeDestroy() {},
  watch: {
    "$vxRoute.vx_action": function (nv, ov) {
      // console.log(nv);
      if (nv == "vx-out") {
        this.visible = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.filtrate-container {
  background: transparent;
  .mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(var(--black-rgb), 0.7);
    z-index: 1;
  }
  .side {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: var(--x3-slide-left);
    background: var(--g1);
    z-index: 2;
  }
  .wrap {
    display: flex;
    flex-direction: column;
    font-size: var(--fs-md);
    color: var(--g8);
    background: var(--white);
    .main {
      flex: 1;
      overflow-y: auto;
      .nav-wrapper {
        margin-left: calc(var(--gap) * 16);
        .nav-title {
          padding: calc(var(--gap) * 8) calc(var(--gap) * 16) calc(var(--gap) * 16) 0;
          font-size:var(--fs-lg);
          line-height:var(--lh-lg);
        }
        .date-box {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
</style>